import React from 'react'
import DataPage from './Data'

const Data = () => (
  <DataPage/>
)

export default Data
